export default __webpack_public_path__ + "50814cabfd9b75cfb49b78c2bc7c9cf1.png";